/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

export interface IncidentStatisticsDto {
  /** Total incidents matching the filters */
  total: number;
  critical: number;
  major: number;
  minor: number;
  /** Incidents created since the start of the requester's local day (see x-timezone header) */
  createdToday: number;
  /** Percentage of matched incidents currently resolved, 0-100 */
  resolvedRatio: number;
}
